export default __webpack_public_path__ + "static/portfolio_gallery_3-1cfe6533e7861c010cf04d635d413340.jpg";